"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icon = (function () {
    function Icon() {
    }
    return Icon;
}());
exports.Icon = Icon;
var IconType;
(function (IconType) {
    IconType[IconType["FONT_AWESEOME"] = 0] = "FONT_AWESEOME";
    IconType[IconType["BOOTSTRAP"] = 1] = "BOOTSTRAP";
})(IconType = exports.IconType || (exports.IconType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/lib/icon.ts
// module id = 3
// module chunks = 0 1